<template>
    <div id="profile">
        <div class="box" id="title">
            <h1 class="title has-text-grey-dark"><i class="fa fa-user"></i> Profile</h1>
            <!--<p class="subtitle">Dear teacher, please enter your details below</p>-->
        </div>
        <!--<hr>-->

        <div class="columns box" v-if="!loading && user.subscription.status != 'active' && user.subscription.status != 'past_due'"  data-tour-profile-step="4">
            <div class="column">
                <p class="title is-3 has-text-grey-dark" >Choose your subscription plan </p><!-- v-if="!this.user.subscription.product_id"-->
                <!--<p class="title is-3 has-text-grey-dark" v-else>2: Procceed with checkout </p>-->
                <!--<hr>-->
                <!--<div class="columns is-multiline" > v-if="user.subscription.product_id"
                    <div class="column is-4">
                        <div class="field">
                            <span class="heading has-text-grey-dark">Got a coupon?</span>
                            <p class="control has-icons-right" v-bind:class="{'is-loading': checkingCoupon}">
                                <input type="text" name="coupon" class="input" v-model="coupon.code" placeholder="Copy it here..."/>
                                <span class="icon is-small has-text-success is-right" v-if="coupon.message && coupon.message.success">
                                      <i class="fa fa-check"></i>
                                    </span>
                                <span class="icon is-small has-text-danger is-right" v-if="coupon.message && !coupon.message.success">
                                      <i class="fa fa-times"></i>
                                    </span>
                            </p>
                        </div>
                    </div>
                    <div class="column is-2">
                        <div class="field" id="checkout">
                            <span class="heading has-text-white">_</span>
                            <a class="button is-fullwidth is-success" @click="procceedWithPlan" >
                                    <span class="icon">
                                        <i class="fa fa-shopping-cart"></i>
                                    </span>
                                <span>Checkout</span>
                            </a>
                        </div>
                    </div>
                    <div class="column is-2">
                        <div class="field" id="checkout">
                            <span class="heading has-text-white">_</span>
                            <a class="button is-fullwidth is-danger" @click="cancelCheckout()">
                                    <span class="icon">
                                        <i class="fa fa-times"></i>
                                    </span>
                                <span>Cancel</span>
                            </a>
                        </div>
                    </div>
                </div>-->
                <hr>
                <div v-if="user.old" class="pricing-table" > <!--v-show="!user.subscription.product_id"-->
                    <div class="pricing-plan is-black clickable" @click="choosePlan(527533)" v-bind:class="{'is-active': user.subscription.product_id == '527533'}"  v-scroll-to="'#checkout'">
                        <div class="plan-header">Beginner</div>
                        <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>6.99</span></div>
                        <div class="plan-items">
                            <div class="plan-item">Unlock full features of BlaBla Commentz platform for 1 month</div>
                            <div class="plan-item">Pay each month</div>
                            <div class="plan-item">-</div>
                        </div>
                        <div class="plan-footer">
                            <a href="javascript:{}" class="button is-fullwidth" @click="choosePlan(527533)" v-scroll-to="'#checkout'">Choose</a>
                        </div>
                    </div>

                    <div class="pricing-plan is-warning clickable" @click="choosePlan(527534)" v-bind:class="{'is-active': user.subscription.product_id == '527534'}"  v-scroll-to="'#checkout'">
                        <div class="plan-header">Experienced</div>
                        <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>34.95</span></div>
                        <div class="plan-items">
                            <div class="plan-item">Unlock full features of BlaBla Commentz platform for 6 months</div>
                            <div class="plan-item">Pay every 6 months</div>
                            <div class="plan-item">Get 1 month for free</div>
                        </div>
                        <div class="plan-footer">
                            <a href="javascript:{}" class="button is-fullwidth" @click="choosePlan(527534)">Choose</a>
                        </div>
                    </div>

                    <div class="pricing-plan is-primary clickable" @click="choosePlan(527535)" v-bind:class="{'is-active': user.subscription.product_id == 527535}" v-scroll-to="'#checkout'">
                        <div class="plan-header">Professional</div>
                        <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>69.99</span></div>
                        <div class="plan-items">
                            <div class="plan-item">Unlock full features of BlaBla Commentz platform for 12 months</div>
                            <div class="plan-item">Pay every 12 months</div>
                            <div class="plan-item">Get 2 months for free</div>
                        </div>
                        <div class="plan-footer">
                            <a href="javascript:{}" class="button is-fullwidth" @click="choosePlan(527535)">Choose</a>
                        </div>
                    </div>
                </div>

                <div v-else class="pricing-table" > <!--v-show="!user.subscription.product_id"-->
                    <div class="pricing-plan is-black clickable" @click="choosePlan(576161)" v-bind:class="{'is-active': user.subscription.product_id == '576161'}"  v-scroll-to="'#checkout'">
                        <div class="plan-header">Beginner</div>
                        <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>9.99</span></div>
                        <div class="plan-items">
                            <div class="plan-item">Unlock full features of BlaBla Commentz platform for 1 month</div>
                            <div class="plan-item">Pay each month</div>
                            <div class="plan-item">-</div>
                        </div>
                        <div class="plan-footer">
                            <a href="javascript:{}" class="button is-fullwidth" @click="choosePlan(576161)" v-scroll-to="'#checkout'">Choose</a>
                        </div>
                    </div>

                    <div class="pricing-plan is-primary clickable" @click="choosePlan(576163)" v-bind:class="{'is-active': user.subscription.product_id == 576163}" v-scroll-to="'#checkout'">
                        <div class="plan-header">Professional</div>
                        <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>99.99</span></div>
                        <div class="plan-items">
                            <div class="plan-item">Unlock full features of BlaBla Commentz platform for 12 months</div>
                            <div class="plan-item">Pay every 12 months</div>
                            <div class="plan-item">Get 2 months for free</div>
                        </div>
                        <div class="plan-footer">
                            <a href="javascript:{}" class="button is-fullwidth" @click="choosePlan(576163)">Choose</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="columns box" v-if="!loading && user.subscription.status == 'active' && user.subscription.subscription_plan_id != null">
            <div class="column">
	            <p class="title is-3 has-text-grey-dark">Active subscription plan: <span :class="getPlan(user.subscription.subscription_plan_id).color">{{getPlan(user.subscription.subscription_plan_id).name}}</span> <span class="title is-5 has-text-grey-dark has-text-weight-normal">({{getPlan(user.subscription.subscription_plan_id).description}})</span></p>
	            <p v-if="!user.subscription.expired" class="is-size-6"><b>Subscription active until <span class="has-text-danger"><i>{{user.subscription.next_bill_date}}</i></span></b></p>
	            <p v-else class="is-size-6 has-text-danger"><b>Subscription expired</b></p>
	            <p></p>
                <hr>
                <div class="buttons">
                    <!--<a href="javascript:{}" class="button is-info" v-if="user.subscription.update_url" @click="updatePlan">Change payment method</a>-->
                    <a href="javascript:{}" class="button is-danger" v-if="user.subscription.cancel_url" @click="cancelPlan">Cancel subscription</a>
                </div>
            </div>
        </div>

        <div class="columns box" v-if="!loading && user.subscription.status == 'past_due' && user.subscription.subscription_plan_id != null">
            <div class="column">
                <div class="notification is-danger has-text-centered">
                    Your subscription is past due, please make sure that you have sufficient funds in your account in order to process this payment. <span v-if="user.subscription.cancel_url"> Or you can <a href="javascript:{}" @click="cancelPlan">cancel your subscription</a> </span>
                </div>

            </div>
        </div>
        <clip-loader v-if="loading"></clip-loader>
        <div  v-else class="columns is-multiline box">
            <div class="column is-3-fullhd is-12-mobile is-12-tablet has-text-centered">
                <div class="field">
                    <vue-avatar v-if="user.id"
                                ref="vueavatar"
                                :image="axios.defaults.storageURL + user.profile.avatar"
                    >
                    </vue-avatar>
                    <a class="button is-primary" @click="selectPhoto">
                        <span class="icon">
                          <i class="fa fa-camera"></i>
                        </span>
                        <span>Choose photo</span>
                    </a>
                </div>
	            <p v-if="!user.subscription.expired" class="is-size-6"><b>Subscription active until <span class="has-text-danger"><i>{{user.subscription.next_bill_date}}</i></span></b></p>
	            <p v-else class="is-size-6 has-text-danger"><b>Subscription expired</b></p>
            </div>
            <div class="column is-3-fullhd is-12-mobile is-6-tablet" v-show="!loading">
                <p class="title is-3 has-text-grey-dark">Basic info</p>
                <hr>
                <form>
                    <div class="field p5">
                        <span class="heading has-text-grey-dark">Email</span>
                        <bulma-input type="text" name="email" v-model="user.email" rules="required" placeholder='User email' disabled/>
                    </div>
                    <div class="field p5">
                        <span class="heading has-text-grey-dark">Name</span>
                        <bulma-input type="text" name="name" v-model="user.profile.name" rules="required" placeholder='User name'/>
                    </div>
                    <div class="field p5">
                        <span class="heading has-text-grey-dark">Nick</span>
                        <bulma-input type="text" name="nick" v-model="user.profile.nick" rules="required" placeholder='User nick'/>
                    </div>
                    <div data-tour-profile-step="1">
                        <div class="field p5">
                            <span class="heading has-text-grey-dark">Select Your Schools</span>
                            <span class="help">Don't see your school? <router-link to="/dashboard/ticket"><u> Contact us</u></router-link> and we will add it!</span>
                            <div class="select is-info is-fullwidth">
                                <select v-model="selectedSchool">
                                    <option v-for="school in schools" v-bind:value="school.id">{{school.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="field p5 is-grouped is-grouped-multiline" v-if="mySchools && mySchools.length > 0">
                            <div class="control" v-for="(school, index) in mySchools">
                                <div class="tags has-addons">
                                    <a class="tag is-primary">{{school.name}}</a>
                                    <a class="tag is-delete" @click="removeSchool(school)"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="field p5" data-tour-profile-step="2">
                        <div class="control"  >
                            <loading-button v-bind:loading="saving" color="is-info" @click="update">Save</loading-button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="column is-offset-1-fullhd is-4-fullhd is-12-mobile is-6-tablet" v-if="!loading">
                <p class="title is-3 has-text-grey-dark">Share BlaBla with your friends</p>
                <hr>
                <form>
                    <div class="field columns">
                        <div class="column is-6">
                            <div class="box notification is-danger">
                                <div class="heading has-text-centered">Free months</div>
                                <div class="title has-text-centered is-1">{{user.free_months}}</div>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div class="box notification is-info">
                                <div class="heading has-text-centered">Referred users</div>
                                <div class="title has-text-centered is-1">{{user.referrals}}</div>
                            </div>
                        </div>
                    </div>
                    <div  class="p5" data-tour-profile-step="3">
                        <div class="field">
                            <span class="heading has-text-grey-dark">Referral url</span>
                            <input class="input" type="text" v-model="user.referral_url" rules="required" readonly/>
                        </div>
                        <div class="field">
                            <div class="control has-text-centered">
                                <a href="javascript:{}" class="icon-button facebook is-size-4-mobile" @click="shareFb"><i class="icon-facebook fab fa-facebook-f"></i><span></span></a>
                                <a href="javascript:{}" class="icon-button linkedin is-size-4-mobile" @click="shareLinkedin"><i class="icon-linkedin fab fa-linkedin-in"></i><span></span></a>
                                <a href="javascript:{}" class="icon-button twitter is-size-4-mobile" @click="shareTwitter"><i class="icon-twitter fab fa-twitter"></i><span></span></a>
                                <a href="javascript:{}" class="icon-button google-plus is-size-4-mobile" @click="shareGoogle"><i class="icon-google-plus fab fa-google-plus-g"></i><span></span></a>
                                <a href="javascript:{}" class="icon-button pinterest is-size-4-mobile" @click="sharePin"><i class="icon-pinterest fab fa-pinterest-p"></i><span></span></a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!--<div id="coupon-modal" class="modal is-small" v-bind:class="{'is-active': showCouponModal}">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Have a coupon?</p>
                    <button class="delete" aria-label="close" @click="showCouponModal = false"></button>
                </header>
                <section class="modal-card-body">
                    <div class="columns is-multiline">
                        <div class="column is-12">
                            <div class="field">
                                <button class="button is-fullwidth is-info is-pulled-right" @click="procceedWithPlan">Next</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>-->
        <vue-tour ref="tour" :active="tourActive" :startStep="4"  :steps="tourSteps" btnDoneText="Next page" @onNextPage="nextPage" @onSkip="skipTour" @onStart="startTour"></vue-tour>
        <trial-extend-modal :show="showExtendModal" @onTrialExtended="trialExtended" @onClose="closeExtendTrialModal"></trial-extend-modal>
    </div>
</template>
<script>

import VueAvatar from '../components/util/VueAvatar'
import Form from '../utils/Form';
import TrialExtendModal from '../components/subscription/TrialExtendModal'

export default {
  name: 'profile',
  components: {VueAvatar,TrialExtendModal},
  data() {
        return {
            loading: false,
            saving: false,
            avatarChanged: false,
            user: {
                email: '',
                profile:{
                },
                subscription:{
                    product_id: ''
                }
            },
            coupon:{
                code: '',
                message: null,
            },
            checkingCoupon: false,
            schools: [],
            mySchools : [],
            selectedSchool : {id: -1, name: ''},
            showExtendModal: false,
            tourSteps: [
                {
                    element: "[data-tour-profile-step='1']",
                    text: '<p class="has-text-justified"> Please select <strong>all</strong> schools you teach for to access their <strong>lesson</strong> & <strong>student</strong> database <p><br> <p> <em> *Selecting the correct schools is <strong> crucial</strong> as it allows you to use <strong>Student ID </strong> and <strong>Lesson ID</strong> numbers effectively </em> </p>'
                },
                {
                    element : "[data-tour-profile-step='2']",
                    text : '<p class="has-text-justified"> Click <strong class="has-text-info">Save</strong> to confirm changes </p>',
                },
                {
                    element: "[data-tour-profile-step='3']",
                    text: '<p class="has-text-justified"> This is your <strong>referral </strong> link, share <strong class="has-text-primary"> BlaBLa </strong> with your friends and win <strong>FREE</strong> Subscriptions<br><br><em>*For every <strong>2 </strong> monthly subscriptions paid by your referrals  you’ll win a <strong>FREE </strong> monthly subscription!</em></p>',
                    options : {
                        nextPage : '/dashboard/comments',
                        nextPageText : 'Next page',
                    }
                },

            ],
        }
  },
  created(){

  },
  mounted(){
    this.loadPageData();
  },
  methods: {
        loadPageData(){
            this.favCommentsLoading = true;
            this.historyCommentsLoading = true;
            this.loading = true;
            let self = this;
            this.pageRepo.getProfileData(this.$route.path).then(response => {
                let data = response.data.data;

                this.schools = data.allSchools;
                //prepare profile
                this.user = data.me;
                if(this.user.profile.schools && this.user.profile.schools.length > 0){
                  this.mySchools =  JSON.parse(JSON.stringify(this.user.profile.schools));
                }

                if(this.user.subscription.offer_extend){
                  this.showExtendModal = true;
                }

                else{
                    if(data.tour.show) {
                        this.tourActive = true;
                    }
                }

                this.loading = false;

                if(this.user.subscription.status != 'active'){

                  this.tourSteps.push(
                      {
                          element: "[data-tour-profile-step='4']",
                          text: '<p class="has-text-justified"> These are <strong class="has-text-primary"> Subscriptions</strong>, please select the one best suited to your needs<br><br><em>*<strong>Subscriptions</strong> are auto-renewable, please purchase one and you’ll have <strobg>full </strobg> access to all of the features</em></p>',
                          options : {
                              nextPage : '/dashboard/comments',
                              nextPageText : 'Next page',
                          }
                      }
                  );
                }

            }).finally(() => {
              this.loading = false;
            });
      },

      closeExtendTrialModal(){
          this.showExtendModal = false;
      },

      trialExtended(me){
          this.$parent.me = me;
          this.user = me;
      },

      selectPhoto(){
          document.getElementById('ab-1').click();
      },
      shareFb(){
          this.share("https://www.facebook.com/sharer/sharer.php?u=", "Facebook share");
      },

      shareTwitter(){
          this.share("https://twitter.com/home?status=", "Twitter share");
      },

      shareLinkedin(){
          this.share("https://www.linkedin.com/shareArticle?mini=true&title=Checkout%20BlaBla%20Commentz&summary=Checkout%20this%20awesome%20application%20for%20ESL%20teachers!&url=", "Linkedin share");
      },

      sharePin(){
          this.share("https://pinterest.com/pin/create/button/?&media=https://blablacommentz.com/img/header_new.PNG&url=", "Pinterest share");
      },

      shareGoogle(){
          this.share("https://plus.google.com/share?url=", "Google+ share");
      },

      share(url, title){
          window.open(url + this.user.referral_url, title, 'width=600,height=300'); return false;
      },

      choosePlan(product_id){
          //this.coupon.code = '';
          this.$refs.tour.done();
          this.user.subscription.product_id = product_id;
          this.$forceUpdate();

          this.procceedWithPlan();
      },

      procceedWithPlan(){

          let self = this;
          //coupon: this.coupon.code,
          Paddle.Checkout.open({
              product: this.user.subscription.product_id,

              passthrough: this.user.email,
              //email: this.user.email,
              successCallback: function(){
                  self.$swal(
                      'Congratulations!',
                      'Your subscription is now active. For any questions please email <a href="/dashboard/ticket">support@blablacommentz.com</a>',
                      'success'
                  ).then((result) => {
                      location.reload();
                  });
              }
          }, false);
      },

      updatePlan(){
          let url = this.user.subscription.update_url;
          Paddle.Checkout.open({
              override: url
          });
      },

      cancelPlan(){
          let url = this.user.subscription.cancel_url;
          Paddle.Checkout.open({
              override: url,
              success: '/dashboard/profile',
              closeCallback: function(){
                  self.$swal(
                      ':(',
                      'Sorry to see you leave! If you change your mind you can always add new subscription plans',
                      'success'
                  ).then((result) => {
                      location.reload();
                  });
              }
          }, false);
      },

      checkCoupon(){
          this.checkingCoupon = true;
          this.paddleRepo.check({code: this.coupon.code, subscription_id: this.user.subscription.product_id}).then((response)=>{
              this.coupon.message = {
                  success: true,
                  text: response.data.message
              }
          }).catch((response)=>{
             this.coupon.message = {
                 success: false,
                 text: response.data.message
             }
          }).finally(() => {
              this.checkingCoupon = false;
          });
      },
        update() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.saving = true;
                    let extendMessage = '';

					let oldSchools = _.map(this.user.profile.schools, 'id');
					let newSchools = _.map(this.mySchools, 'id');

					if( (!oldSchools.includes(this.VIPKID.id) && newSchools.includes(this.VIPKID.id)) ){//(!oldSchools.includes(this.MAGIC_EARS.id) && newSchools.includes(this.MAGIC_EARS.id) ||
                        extendMessage = ' VIPKID school detected. Additional sentences and templates are now available and added to your profile.'
                    }

                    let data = {
                        schools: _.map(this.mySchools, 'id'),
                        name: this.user.profile.name,
                        nick: this.user.profile.nick,
                    };

                    if(this.$refs.vueavatar.imageChanged()){
                        data.avatar = this.$refs.vueavatar.getImage();
                    }

                    this.userRepo.update(Form.prepare(data), 'profile.school').then(response => {
                        this.saving = false;
                        this.$parent.me = response.data.data;
                        this.user = response.data.data;
                        this.$toast.info(response.data.message + extendMessage);
                    }).catch((response) =>{
                        this.saving = false;
                        return Promise.reject(response);
                    });
                }
            });
        },
      removeSchool(school){
          let index = _.findIndex(this.mySchools, function(s) { return s.id == school.id; });
          if( index != -1){
              this.mySchools.splice(index, 1);
          }
      },

  },
  watch: {
      user:function(value){
      },
      'coupon.code':_.debounce(function(value){
            this.coupon.message = null;
            if(!value){
                return;
            }
            this.checkCoupon();
      }, 800),
      showCouponModal: function(value){
          this.coupon.message = null;
          this.coupon.code = '';
      },
      'selectedSchool' : function(value){
          if(_.findIndex(this.mySchools, function(s) { return s.id == value; }) == -1) {
              let newSchool = this.schools[_.findIndex(this.schools, function (s) {
                  return s.id == value;
              })];

              if(newSchool !== null && newSchool !== undefined) {
                  this.mySchools.push(newSchool);
              }
          }
      },

  }

}
</script>

<style lang="css" scoped>

    #coupon-modal .modal-card{
        width: 340px;
    }

    .pricing-table .pricing-plan.is-active {
        /*box-shadow: none;*/
        transform: scale(1.05);
    }

    .pricing-table .pricing-plan.is-warning.is-active {
        border: 1px #ffdd57 solid;
    }

    .pricing-table .pricing-plan.is-black.is-active {
        border: 1px #9370DB solid;
    }

    .pricing-table .pricing-plan.is-primary.is-active {
        border: 1px #00d1b2 solid;
    }

    #school-tags{
        margin-top: 10px;
    }

    #school-tags .tag.is-delete{
        margin-right: 5px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/Profile.vue